import en from '@/assets/i18n/en.json'
import no from '@/assets/i18n/no.json'
import sv from '@/assets/i18n/sv.json'
import zh_CN from '@/assets/i18n/zh_CN.json'
import zh_HK from '@/assets/i18n/zh_HK.json'
import Vue from 'vue'
import vuei18n from 'vue-i18n'

import elementUiEnLocale from 'element-ui/lib/locale/lang/en'
import elementUiZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementUiNoLocale from 'element-ui/lib/locale/lang/nb-NO'
import elementUiSeLocale from 'element-ui/lib/locale/lang/sv-SE'

Vue.use(vuei18n)
export default new vuei18n({
    locale: localStorage.getItem("lang") || "en-US",
    messages: {
        en: { ...en, ...elementUiEnLocale },
        no: { ...no, ...elementUiNoLocale },
        sv: { ...sv, ...elementUiSeLocale },
        'en-GB': { ...en, ...elementUiEnLocale },
        'en-US': { ...en, ...elementUiEnLocale },
        'nb-NO': { ...no, ...elementUiNoLocale },
        'sv-SE': { ...sv, ...elementUiSeLocale },
        'zh-CN': { ...zh_CN, ...elementUiZhLocale },
        'zh-HK': { ...zh_HK, ...elementUiZhLocale },
    },
    silentTranslationWarn: true
})
